module.exports = __webpack_public_path__ + "img/orange_clipboard.a284c60f.svg";